/*jslint white: true, plusplus: true, vars: true, undef: true, sloppy: true */
// 'use strict'
/* global expocadfx, Transform*/


expocadfx.Drawing = function() {
    var config = expocadfx.config;
    var data = expocadfx.fxData;
    var elemById = expocadfx.element.elementById;
    var FxEvent = expocadfx.fxevent;
    var util = expocadfx.util;
    var mtx = new Transform();
    
    var doc = document;
    var mouseY = screenY;
    var mouseX = screenX;
    var arBoothGraphics = data.boothGraphics;
    
    var arFavorites = data.favoriteMarks2d;
    var arHighlight = [];
    var arSelected = data.selected2d;
    var arOutline = [];
    var arOutlineParams = [];
    var arCanvas = [];
    
    var boothContext = null;
	var boothTextContext = null;
    var fitScale = 0;
    var centerX = 0;            // floor plan point that is at the center of the window
    var centerY =0;
    var bBuildingJpegReady = false;
    var buildingImage = null;
    var initialOffsetX = 0;
    var initialOffsetY = 0;
    var iAmHereSymbol = null;
    var iAmHereText = "";
        // keep track of array lengths outside of loop
    var numBooths = 0;
    var numFavorites = 0;
    
    var updateNeeded = true;
	var updateTimer = null;
    var lastDrawTime = 0;
    var loopStarted = false;
    var numSelectAnimate = 0;
    
    var effectInProgress = false;
    var zooming = false;
    var panning = false;
    var zoomFinalScale = 0.0;
    var zoomChange = 0;
    var ZOOM_RATE = 0.001;
    var zoomStepSize = 0.0;
    var lastStepTime = 0;
    
    var panFinalX = 0;
    var panFinalY = 0;
    var panDist;
    var panSin;
    var panCos;
    
    var BASE = 0;
    var BOOTH = 1;
    var MARKER = 2;
    var BOOTH_TEXT = 3;
    
    var pointerAt = {};
//    var throb = 2;
	var isReady = false;
	var i = 0;
	var canvas = null;
	var ctx = null;
	
	var pdf = null;
	
    var containerWidth = elemById( "floorplan").clientWidth;
    var containerHeight = elemById( "floorplan").clientHeight;
	var container = elemById( "fpContainer");
	
	container.style.backgroundColor = config.clrBackground;  //  move to setup !

	centerX = config.DRAWING_WIDTH / 2;
	centerY = config.DRAWING_HEIGHT / 2;

	fitScale = calculateScale();
		// create a canvas for each 'layer'
	for( i = 0; i < 4; i++) {
		canvas = doc.createElement( "canvas");
		canvas.width = containerWidth;
		canvas.height = containerHeight;
		ctx = canvas.getContext( "2d");
		ctx.textAlign = "center";
		arCanvas.push( {"canvas":canvas, "ctx":ctx});

        container.appendChild( canvas);
	}
	boothContext = arCanvas[BOOTH].ctx;
	boothTextContext = arCanvas[BOOTH_TEXT].ctx;
	
	calculateInitialOffset();
	fitDrawing();
        
    
    function addBuilding( image) {
        buildingImage = image;
        bBuildingJpegReady = true;
        updateNeeded = true;
    }

    function completeSetup() {
		data.boothGraphics.forEach( function( graphic) {
            setBoothFillStyle( graphic);
        });
        drawFloorPlan();
		doc.dispatchEvent( new FxEvent( "Floor_Plan_Ready", null));
		isReady = true;
    }
    
    function setBoothFillStyle( graphic) {	//  set 2d fillStyle !!
        if( config.bBoothGradient) {
            if( graphic.fillColor !== "") {
                graphic.fillStyle = createBoothGradient( graphic);
                graphic.displayColor = graphic.fillStyle;
            }
        }
        else {
            graphic.fillStyle = graphic.fillColor;
        }
    }

    function enableEvents() {
        document.addEventListener( "Mini_Map_Change", miniMapHandler);
    }
    
    function disableEvents() {
        document.removeEventListener( "Mini_Map_Change", miniMapHandler);
    }
    
    function createBoothGradient( obj) {
        var grad = boothContext.createLinearGradient( obj.maxX, obj.maxY, obj.minX, obj.minY);
        grad.addColorStop( 0, obj.fillColor);
        grad.addColorStop( 0.8, config.clrBoothBase);
        return grad;
    }
    
    function calculateScale() {
        return Math.min( containerWidth / config.DRAWING_WIDTH,
                        containerHeight / config.DRAWING_HEIGHT);
    }
    
    function calculateInitialOffset() {
            initialOffsetX = ( containerWidth / fitScale - config.DRAWING_WIDTH) / 2;
            initialOffsetY = ( containerHeight / fitScale - config.DRAWING_HEIGHT) / 2;
    }
    
    function fitDrawing() { 
        var i = 0;
        mtx= new Transform();
        mtx.scale( fitScale, fitScale);
        mtx.translate( initialOffsetX, initialOffsetY);
		
        for( i = 0; i < 4; i++) {
            arCanvas[i].ctx.setTransform( mtx.m[0], mtx.m[1], mtx.m[2], mtx.m[0], mtx.m[4], mtx.m[5]);
        }
        centerX = config.DRAWING_WIDTH / 2;
        centerY = config.DRAWING_HEIGHT / 2;
        updateNeeded = true;
    }
    
    function resizeHandler() {
        var currentCenterX = centerX;
        var currentCenterY = centerY;
        var dw = 0;
        var dh = 0;
        
        var oldWidth = containerWidth;
        var oldHeight = containerHeight;
        var oldFitScale = fitScale;
        
		var currentScale = mtx.m[0];
        var m1 = mtx.m[1];          // y skew
        var m2 = mtx.m[2];          // x skew
        var m4 = mtx.m[4];          // x translation
        var m5 = mtx.m[5];          // y translation
        var i = 0;
        
        
        containerWidth = container.clientWidth;
        containerHeight = container.clientHeight;
        fitScale = calculateScale();
        
        calculateInitialOffset();
	
        for( i = 0; i < 4; i++) {
            arCanvas[i].canvas.width = containerWidth;
            arCanvas[i].canvas.height = containerHeight;
        }
        
        if( currentScale === oldFitScale && centerX === config.DRAWING_WIDTH/2 &&
                    centerY === config.DRAWING_HEIGHT/2) {
            fitDrawing();
        }
        else if( centerX === config.DRAWING_WIDTH / 2 && centerY === config.DRAWING_HEIGHT / 2) {
            if( currentScale > fitScale) {
                fitDrawing();
                adjustZoomToScale( currentScale / mtx.m[0]);   // mtx after fitting drawing
            }
            else {
                fitDrawing();
            }
        }
        else {                  //  scale change and/or drawing has been translated !!
            dw = (oldWidth - containerWidth) / 2;       // change in screen pixels
            dh = (oldHeight - containerHeight) / 2;
            
            dw = Math.round( dw / currentScale);           // change in drawing pixels
            dh = Math.round( dh / currentScale);   
            
            if( fitScale < currentScale) {
                for( i = 0; i < 4; i++) {
                    arCanvas[i].ctx.setTransform( currentScale, m1, m2, currentScale, m4, m5);
                }
                moveCanvas( -dw, -dh);
                updateNeeded = true;
            }
            else {
                fitDrawing();
                moveCanvas( centerX - currentCenterX, centerY - currentCenterY);
            }
            centerX = currentCenterX;
            centerY = currentCenterY;
        }
        
        return { x: initialOffsetX, y: initialOffsetY};
    }

    function adjustZoomToScale( scale) {
        var i = 0;

        mtx.translate( centerX, centerY);
        mtx.scale(scale, scale);
        mtx.translate( -centerX, -centerY);
        for( i = 0; i < 4; i++) {
            arCanvas[i].ctx.translate( centerX, centerY);
            arCanvas[i].ctx.scale(scale, scale);
            arCanvas[i].ctx.translate( -centerX, -centerY);
        }
        updateNeeded = true;
    }

    elemById('floorplan').addEventListener('mousemove', function(evt){
        mouseY = evt.clientY;
        mouseX = evt.clientX

        // Green Circle center point for debugging!
        // var radius = 70;

        // ctx.beginPath();
        // ctx.arc(centerX, centerY, radius, 0, 2 * Math.PI, false);
        // ctx.fillStyle = 'green';
        // ctx.fill();
        // ctx.lineWidth = 500;
        // ctx.strokeStyle = '#003300';
        // ctx.stroke(); 
    })

    function adjustScaleToCursor( scale) {
        var i = 0;
        var pt = globalToFloorPlan( { "x":mouseX, "y":mouseY});

        mtx.translate( pt.x,pt.y);
        mtx.scale(scale, scale);
        mtx.translate( -pt.x,-pt.y);

        for( i = 0; i < 4; i++) {    
            arCanvas[i].ctx.translate( pt.x,pt.y);
            arCanvas[i].ctx.scale(scale, scale);
            arCanvas[i].ctx.translate( -pt.x,-pt.y);
        }

        centerX = pt.x + (centerX - pt.x) / scale;
        centerY = pt.y + (centerY - pt.y) / scale;
        
        updateNeeded = true;
    }
    
    function hitTest( screenX, screenY) {
        //  need to allow for scale, offset, and header height !!!
        var hitObj = null;
        var len = data.arOverlays.length;
        var i = 0;
        var overlay = null;
        var booth = null;
        var pt = globalToFloorPlan( { "x":screenX, "y":screenY});
		
		numBooths = data.boothGraphics.length;
        for( i = 0; i < numBooths; i++) {
            booth = arBoothGraphics[i];
            if( booth.status !== 4) {
                if( pt.x >= booth.minX &&
                   pt.x <= booth.maxX  &&
                   pt.y >= booth.minY  &&
                   pt.y <= booth.maxY) {
                        //  test that x,y is inside booth, not just bounding box

                    if( booth.path !== null) {
                        if( isInObject( booth, screenX, screenY)) {
                            hitObj = data.booths[ booth.index];
                            break;
                        }
                    }
                }
            }
        }
        if( hitObj === null) {
            for( i = 0; i < len; i++) {
                overlay = data.arOverlays[i];
                if( overlay.ready) {
                    if( pt.x >= overlay.minX && pt.x <= overlay.maxX  &&
                       pt.y >= overlay.minY  && pt.y <= overlay.maxY) {
                        hitObj = overlay;
                        break;
                    }
                }
            }
        }
        return hitObj;
    }
    
    function globalToFloorPlan( gPt) {
        var lPt = {};
        lPt.x = Math.round( ( gPt.x - mtx.m[4]) / mtx.m[0]);
        lPt.y = Math.round( ( gPt.y - mtx.m[5]) / mtx.m[0]);
        //ctx.fillRect(lPt.x, lPt.y,1,1);

        return lPt;
    }
    
    function floorPlanToGlobal( lPt) {
        var gPt = {};
        gPt.x = lPt.x * mtx.m[0] + mtx.m[4];
        gPt.y = lPt.y * mtx.m[0] + mtx.m[5];
        return gPt;
    }
    
    function ajaxCall(url, mthd, data) {
        $.ajax({
            url: url,
            contentType: "text/plain; charset=utf-8",
            processData: false,
            method: mthd,
            data:  data,
            dataType: "text",
            success: function () {
                console.log("yay");
            },
            error: handleError(),
        });
    }
    function handleError(e) {
        console.log(e);
    }
    //should I store this somewhere else, along with other JSON schemas...

    // var coordsObj = `{
    //                     "coordinates": {
    //                         "Geometry": {
    //                             "CoordinateSystemId": 4326,
    //                             "WellKnownText": ""
    //                         }
    //                     },
    //                     "start_point": null,
    //                     "rotation_degrees": null
    //                 }`;

    // refactor to allow for rectangles
    function getCornersOfSquare(x, y, side) {
        var ret = [];
        ret.push(x + " " + y);

        ret.push(x + " " + (y + (side * 19.25)));
        ret.push(x + side * 19.25 + " " +  (y + (side * 19.25)));
        ret.push(x + side * 19.25 + " " + y);

        ret.push(x + " " + y);
        return ret;
    }

     function pointerDownAt( pointerX, PointerY) {
         pointerAt = globalToFloorPlan( { x:pointerX, y:PointerY});

                
        // var clickToDrawBooth = false;
        // if (clickToDrawBooth) {
        //     ctx.beginPath();
        //     ctx.lineWidth = "1";
        //     ctx.strokeStyle = "red";
        //     // convert to 10 x 10
        //     ctx.fillStyle = "rgba(255, 99, 71, 0.2)";
        //     ctx.fillRect(pointerAt.x, pointerAt.y, 10 * 19.25, 10 * 19.25);
        //     var theCoords = getCornersOfSquare(pointerAt.x, pointerAt.y, 10);
            
        //     var polyCoordsStr = "POLYGON ((";
        //     for (var i = 0; i < theCoords.length; i++) {
        //         for (var j = 0; j < theCoords[i].length; j++) {
        //             polyCoordsStr += theCoords[i][j] + " ";
        //         }
        //         if (i != theCoords.length - 1) {
        //             polyCoordsStr += ", "
        //         }
        //     }
        //     polyCoordsStr += "))";
         
        //     var tempJSON = JSON.parse(coordsObj);

        //     tempJSON.coordinates.Geometry.WellKnownText = polyCoordsStr;
        //     coordsObj = JSON.stringify(tempJSON);
        //     ajaxCall("http://localhost:52953/api/booth_coords/Create/", "POST", coordsObj)
        //     ctx.stroke();
        //}

        // var gridBooth = true;
        // // add event listener for this...
        // var sideLen = document.getElementById("sideLength").value;
        // var gWidth = document.getElementById("gWidth").value;
        // var gHeight = document.getElementById("gHeight").value;
        // var vOffset = document.getElementById("vOffset").value;
        
        // if (gridBooth) {
        //     if (vOffset == "") {
        //         drawGridOfBooths(sideLen, gWidth, gHeight);
        //     }
        //     if (vOffset != "") {
        //         drawGridOfBooths(sideLen, gWidth, gHeight, vOffset);
        //     }
        // }
    }
    
    // accepts side length of booth (square only as of now),width and height of grid
    // only allow one instance on screen at once.. add counter
    // offset for making columns or rows
    // function drawGridOfBooths(sideLen, wdth, height, offset) {
    //     if (sideLen / sideLen !== 1) {
    //         // square only.
    //         return;
    //     }
    //     if (wdth < 1 || height < 1) {
    //         return;
    //     }
    //     // don't allow too many booths
    //     if (wdth * height > 400) {
    //         return;
    //     }
    //     var retJSON = [];
    //     var tempJSON = JSON.parse(coordsObj);
        
    //     ctx.lineWidth = "2";
    //     ctx.strokeStyle = "black";
    //     ctx.fillStyle = "rgba(20, 20, 150, .2)";
    //     for (var h = 0; h < height; h++) {
    //         for (var w = 0; w < wdth; w++) {
    //             var startX = pointerAt.x + (sideLen * 19.25 * w);
    //             var startY = pointerAt.y - (sideLen * 19.25 * h);

    //             //maybe only allow columns and rows, but not 'checkerboard' spaced-out booths... probably not common?
    //             if (offset) {
    //                 // not sure if it makes sense to add to canvas here, or store and draw elsewhere...
    //                 ctx.fillRect(startX + (offset * 19.25 * w), pointerAt.y - (sideLen * 19.25 * h), sideLen * 19.25, sideLen * 19.25);
    //                 ctx.strokeRect(startX + (offset * 19.25 * w), pointerAt.y - (sideLen * 19.25 * h), sideLen * 19.25, sideLen * 19.25);

    //                 var temp = getCornersOfSquare(startX + (offset * 19.25 * w), startY, 10);
    //                 tempJSON.coordinates.Geometry.WellKnownText = "POLYGON((" + temp + "))";
    //                 coordsObj = JSON.stringify(tempJSON);
    //                 retJSON.push(coordsObj);
    //             } if (!offset) {
                    
    //                 ctx.fillRect(startX, startY, sideLen * 19.25, sideLen * 19.25);
    //                 ctx.strokeRect(startX, startY, sideLen * 19.25, sideLen * 19.25);
                    
    //                 var temp = getCornersOfSquare(startX, startY, 10);
    //                 tempJSON.coordinates.Geometry.WellKnownText = "POLYGON((" + temp + "))";
    //                 coordsObj = JSON.stringify(tempJSON);
    //                 retJSON.push(coordsObj);
    //             }
    //         }
    //     }
    //     ajaxCall("http://localhost:52953/api/booth_coords/CreateMany/", "POST", JSON.stringify(retJSON))
    // }
    
    function dragTo( pointerX, pointerY) {
        var pt = globalToFloorPlan( { x:pointerX, y:pointerY});
        moveCanvas( pt.x - pointerAt.x, pt.y - pointerAt.y);
    }
    
    function removeBoothText( bth) {
        var graphic = arBoothGraphics[ bth.index];
        
        if( graphic) {
            graphic.text = [];
			graphic.dimensionText = [];
            updateNeeded = true;
        }
    }
    
    function addGraphic( graphic) {
        data.pavilions.push( graphic);
    }
    
    function addOverlays() {
        var numOverlays = data.arOverlays.length;
        var i = 0;
        var checkMinMax = util.updateMinMax;
        var overlay = null;
        var xc = 0;
        var yc = 0;
        var x1 = 0;
        var y1 = 0;
        var r1 = 0;
        var r3 = 0;
        var r2 = 0;
        var t2 = 45 * Math.PI/180;
        var t3 = 90 * Math.PI/180;
        
        
        for( i = 0; i < numOverlays; i++) {
            overlay = data.arOverlays[i];
            if( overlay.ready) {
                xc = Number(overlay.x);
                yc = Number(overlay.y);

                overlay.minX = overlay.maxX = xc;
                overlay.minY = overlay.maxY = yc;

                r1 = overlay.w;
                r3 = overlay.h;
                r2 = Math.sqrt( r1 * r1 + r3 * r3);
                
                overlay.ready = true;

                // create a path array ( if navTo or zoomTo have a value?) for hit test
                overlay.path.push( {"x": xc, "y": yc} );
                checkMinMax( overlay, xc, yc);

                x1 = xc + r1 * Math.cos( overlay.rot);
                y1 = yc + r1 * Math.sin( overlay.rot);
                overlay.path.push( {"x": x1, "y": y1} );
                checkMinMax( overlay, x1, y1);

                x1 = xc + r2 * Math.cos( overlay.rot + t2);
                y1 = yc + r2 * Math.sin( overlay.rot + t2);
                overlay.path.push( {"x": x1, "y": y1} );
                checkMinMax( overlay, x1, y1);

                x1 = xc + r3 * Math.cos( overlay.rot + t3);
                y1 = yc + r3 * Math.sin( overlay.rot + t3);
                overlay.path.push( {"x": x1, "y": y1} );
                checkMinMax( overlay, x1, y1);
            }
        }
        updateNeeded = true;
    }
    
    function highlightBooth( boothIndex) {
        
        if( data.hatchedBooths == true){
            return;
        }
        
        var arTemp = boothIndex === -1 ? [] : String(boothIndex).split( ",");
        var i = 0;
        var graphic = null;
        //  remove existing highlights
        if( arHighlight.length > 0) {
            for( i = 0; i < arHighlight.length; i++) {
                graphic = arBoothGraphics[ arHighlight[i]];
                
                graphic.displayColor = graphic.fillStyle;
            }
        }
        
        if( boothIndex !== "-1") {
            for( i = 0; i < arTemp.length; i++) {
                graphic = arBoothGraphics[ arTemp[i]];
                if( graphic) {
                    graphic.displayColor = config.clrHighlight;
                    // Play with increasing the size of booth on hover, then reset
                    // for( p = 0; p < graphic.path.length; p++){
                    //     graphic.path[p].x += 10;
                    //     graphic.path[p].y += 10; 
                    // }
                }
            }
        }
        arHighlight = ( boothIndex !== "-1") ? arTemp : [];
        updateNeeded = true;
    }
    
    function markSelected( graphicObj) {
        graphicObj.selected = true;
        arSelected.push( createSelectedMark( graphicObj, config.clrSelected));
        numSelectAnimate += 1;
    }
    
    function removeSelected( graphic) {
        var len = arSelected.length;
        var i;
        for( i = 0; i < len; i++) {
            if( arSelected[i].index === graphic.index) {
                arSelected.splice( i, 1);
                break;
            }
        }
        graphic.selected = false;
        updateNeeded = true;
    }
    
    function removeAllSelected() {
        var mark;
        while( arSelected.length > 0) {
            mark= arSelected.pop();
            data.boothGraphics[ mark.index].selected = false;
        }
        numSelectAnimate = 0;
        updateNeeded = true;
    }
    
    function updateSelected( ar) {
        var len = ar.length;
        var i;
        
        for( i = 0; i < len; i++) {
            markSelected( data.boothGraphics[ ar[i].index] );
        }
        updateNeeded = true;
    }
    
    function createSelectedMark( bthGraphic, color) {
        var halfWidth = 0.5 * ( bthGraphic.maxX - bthGraphic.minX);
        var halfHeight = 0.5 * ( bthGraphic.maxY - bthGraphic.minY);
        var radX = Math.round(Math.sqrt( halfWidth * halfWidth + halfHeight * halfHeight));
        
        var mark = {
            index: bthGraphic.index,
            x: bthGraphic.minX + halfWidth,
            y: bthGraphic.minY + halfHeight,
            radius: radX,
            startAngle: 0,
            endAngle: 0,
            strokeColor: color,
			anticlockwise: false
        };   
        return mark;  
    }
    
    function markFavorite( boothIndex) {
        var arTemp = String( boothIndex).split( ",");
        var len = arTemp.length;
        var i;
        var mark = null;
		
        for( i = 0; i < len; i++) {
				//  if not already marked !
			if( util.arrayFind( arFavorites, "index", Number(arTemp[i])) === null) {
				mark = createMark( arBoothGraphics[ arTemp[i]], config.FAVORITE_CHARACTER_CODE,
									config.clrHighlight);
				arFavorites.push( mark);
				numFavorites += 1;
				
			}
        }
        updateNeeded = true;
    }
    
    function removeFavorite( boothIndex) {
        var len = arFavorites.length;
        var i;
        var index = parseInt( boothIndex, 10);
		
        for( i = 0; i < len; i++) {
            if( Number(arFavorites[i].index) === Number(index)) {
                arFavorites.splice( i, 1);
                numFavorites -= 1;
                updateNeeded = true;
                break;
            }
        }
    }
    
    function addToOutline( obj, color, width) {
        var index = arOutline.indexOf( obj);
        if( index === -1) {
            arOutline.push( obj);
            arOutlineParams.push( {"color": color, "width": width});
        }
    }
    
    function removeFromOutline( obj) {
        if( obj === null) {
            arOutlineParams = [];
            arOutline = [];
        }
        else {
            var index = arOutline.indexOf( obj);
            if( index !== -1) {
                arOutlineParams.splice( index, 1);
                arOutline.splice( index, 1);
            }
        }
        updateNeeded = true;
    }
    
    function createMark( boothObj, code, color) {
        var bthWidth = boothObj.maxX - boothObj.minX;
        var bthHeight = boothObj.maxY - boothObj.minY;
        var font = "700 " + (config.scaleFactor / 0.8) + "px 'Font Awesome 5 Free'";			// NO BOLD Font Awesome 5 Free or iOS draws 2 marks
        //  font size needs to be set based on fit scale ( and zoom amount?)
        var mark = {
            index: boothObj.index,
            x: boothObj.minX + 0.5 * bthWidth,
            y: boothObj.minY + 0.5 * bthHeight,
            rotation: 0,
			dRot: 0,		//  for pdf output
            text: String.fromCharCode( code),
            fontSize: config.scaleFactor / 0.8,
            font: font,
            clockwise: 1,
            fill: color
        };   
        return mark;   
    }
    
    function drawPath( path, layer, color, lineWidth) {     //FxSales -mark (outline) selected booths
        var i = 0;
        var len = path.length;
        layer.save();
        layer.globalAlpha = 1;
        layer.strokeStyle = color;
        layer.lineWidth = lineWidth;
        layer.beginPath();
        layer.moveTo( path[0].x, path[0].y);
        for( i = 1; i < len; i += 1) {
            layer.lineTo( path[i].x, path[i].y);
        }
        layer.closePath();
        layer.stroke();
        layer.restore();
    }
    
    function drawBooth( obj, context) {     //pavilions,graphics,and booths in minimap & firefox
        var i;
        if( !obj.path || obj.path.length === 0) {
            return;
        }
        var len = obj.path.length;
        context.save();
        context.globalAlpha = obj.alpha;
        context.strokeStyle = obj.strokeColor;
        context.lineWidth = obj.lineWidth;
        context.fillStyle = obj.displayColor;
        
        context.beginPath();
        context.moveTo( obj.path[0].x, obj.path[0].y);
        for( i = 1; i < len; i += 1) {
            context.lineTo( obj.path[i].x, obj.path[i].y);
        }
        if( obj.type !== "F") {
            context.closePath();
            boothContext.fillStyle = obj.displayColor;
            context.fill();
            
            context.globalAlpha = 1.0;
            context.stroke();
        }
        else {
            context.stroke();
        }
        context.restore();
    }
    
    function drawBoothComposite( obj) {        //  only used for booths
        var i;
        if( !obj.path || obj.path.length === 0) {
            return;
        }
        
        var len = obj.path.length;
        
        boothContext.save();
        boothContext.lineWidth = obj.lineWidth;
            //  remove any Pavilion color before drawing booth
        if( obj.type === "T") {
            boothContext.globalAlpha = 1.0;
            boothContext.globalCompositeOperation = "destination-out";
            boothContext.beginPath();
            boothContext.moveTo( obj.path[0].x, obj.path[0].y);
            for( i = 1; i < len; i += 1) {
                boothContext.lineTo( obj.path[i].x, obj.path[i].y);
            }
            boothContext.closePath();
            boothContext.fill();
            boothContext.globalCompositeOperation = "source-over";
        }
        boothContext.globalAlpha = obj.alpha;
        boothContext.fillStyle = obj.displayColor;
        boothContext.strokeStyle = obj.strokeColor;
		
        boothContext.beginPath();
        boothContext.moveTo( obj.path[0].x, obj.path[0].y);
        for( i = 1; i < len; i += 1) {
            boothContext.lineTo( obj.path[i].x, obj.path[i].y);
        }
        boothContext.closePath();
        
        boothContext.fill();
        
        boothContext.globalAlpha = 1.0;
        boothContext.stroke();
        
        boothContext.restore();
    }
	
	function drawArc( obj, ctx) {
		ctx.save();
        ctx.globalAlpha = obj.alpha;
        ctx.strokeStyle = obj.strokeColor;
        ctx.lineWidth = obj.lineWidth;
		
		ctx.beginPath();
        ctx.arc( obj.x, obj.y, obj.radius, obj.startAngle, obj.endAngle, obj.anticlockwise);
        ctx.stroke();
        ctx.restore();
	}
    
//    function drawSelected( mark, ctx) {
//        ctx.save();
//        ctx.strokeStyle = mark.color;
//        
//        ctx.lineWidth = Math.ceil( 4 / mtx.m[0]);
//        ctx.beginPath();
//        ctx.arc( mark.x, mark.y, mark.radiusX, 0, mark.endAngle);
//        
//        ctx.stroke();
//        ctx.restore();
//    }
    
	function drawFloorPlan() {
		if( data.firefox) {
            //  firefox very slow with globalComposite modes, see Mozilla Bug 762973
            drawWithFunction( drawBooth);
		}
		else {
			drawWithFunction( drawBoothComposite);
		}
	}
    
    function drawWithFunction( drawBoothFunc) {
        var startDrawTime = Date.now();
        var delay = 0;
		var baseContext = arCanvas[BASE].ctx;
        
        updateNeeded = false;
        boothTextContext.textAlign = "center";
		baseContext.textAlign = "center";
		
        arCanvas[MARKER].ctx.textAlign = "center";
        clearCanvas();
        
		data.pavilions.forEach( function( graphic) {
            drawBooth( graphic, boothContext);
        });
		
		arBoothGraphics.forEach( function( graphic) {
            drawBoothFunc( graphic, boothContext, false);
              //  for text grouped with booth object
            graphic.text.forEach( function( txt) {
                util.drawText( boothTextContext, txt);
            });
        });
		arFavorites.forEach( function( fav) {
            util.drawText( arCanvas[MARKER].ctx, fav);
        });
        
		arSelected.forEach( function( selected) {
			selected.lineWidth = ( 4 / mtx.m[0]);
//            drawSelected( selected, arCanvas[MARKER].ctx);
			drawArc( selected, arCanvas[MARKER].ctx);
        });
        
        if( data.bDrawBuilding) {
            if( bBuildingJpegReady) {
                baseContext.drawImage( buildingImage, 0, 0, config.DRAWING_WIDTH, config.DRAWING_HEIGHT);
            }
			
			data.buildingText.forEach( function( txt) {
                util.drawText( baseContext, txt);
            });
			
			data.arTechLayers.forEach( function( group) {
				if( group.visible) {
					group.graphics.forEach( function( graphic) {
						if( graphic.type === "F") {
							drawBooth( graphic, baseContext);
						}
						else {
							drawArc( graphic, baseContext);
						}
					});
					group.txt.forEach( function( txt) {
						util.drawText( baseContext, txt);
					});
				}
			});
        }
			// must be after building
		if( data.addedGraphics) {
			data.addedGraphics.graphics.forEach( function( graphic) {
				if( graphic.type === "F") {
					drawBooth( graphic, baseContext);
				}
				else {
					drawArc( graphic, baseContext);
				}
			});
			data.addedGraphics.txt.forEach( function( txt) {
				util.drawText( baseContext, txt);
			});
		}
		
		
		if( config.showDimensions) {
			arBoothGraphics.forEach( function( graphic) {
				graphic.dimensionText.forEach( function( txt) {
                    util.drawText( boothTextContext, txt);
				});
			});
		}
        
		data.arOverlays.forEach( function( overlay) {
            //console.log(data.arOverlays)
			if( overlay.ready) {
				if( overlay.rot === "0") {
					boothContext.drawImage( overlay.imgElement, overlay.x, overlay.y, overlay.w, overlay.h);
				}
				else {
					boothContext.save();
					boothContext.translate( overlay.x, overlay.y);
					boothContext.rotate( overlay.rot);
					boothContext.drawImage( overlay.imgElement, 0, 0, overlay.w, overlay.h);
					boothContext.restore();
				}
			}
		});
        
		data.floorPlanText.forEach( function( txt) {
            util.drawText( baseContext, txt);
        });
		data.pavilionLabels.forEach( function( txt) {
            util.drawText( boothTextContext, txt);
        });
        
        if( iAmHereSymbol !== null) {
            drawIAmHereSymbol( boothTextContext, iAmHereSymbol);
        }
        
        lastDrawTime = Date.now() - startDrawTime;
		
        delay = Math.max( 40 - lastDrawTime, 30);
        updateTimer = setTimeout( updateCheck, delay);
    }
	
	
	function drawIAmHereSymbol( ctx, obj) {
		var newSize = Math.max( 16, obj.fontSize/mtx.m[0]);
        var locX = obj.x;
        var locY = obj.y;
        
        ctx.save();
        ctx.font = "700 " + newSize + "px 'Font Awesome 5 Free'";  
        ctx.fillStyle = obj.fill;
        ctx.textBaseline = "middle";
        ctx.fillText( obj.text, locX, locY + obj.fontSize/2);
		
        locX = iAmHereText.x;
        locY = iAmHereSymbol.y - 0.8 * newSize;
        ctx.textBaseline = "baseline";
        ctx.fillText( iAmHereText.text, locX, locY);
        
        ctx.restore();
	}
    
    function updateAnimation() {
        var i = 0;
        var lw = 0;
//		var st;
//		var tm;
        
        if( effectInProgress) {
            return;
        }
        if( numFavorites > 0 || numSelectAnimate > 0 || arOutline.length > 0) {
//			st = Date.now();
            //  clear layer
            arCanvas[MARKER].ctx.save();
            arCanvas[MARKER].ctx.setTransform(1,0,0,1,0,0);
            arCanvas[MARKER].ctx.clearRect(0, 0, containerWidth, containerHeight);
            arCanvas[MARKER].ctx.restore();
//            if( numSelected > 0) {
			arSelected.forEach( function( selected) {
				if( selected.endAngle < 2 * Math.PI) {
					selected.endAngle += 0.2 * Math.PI;
					if( selected.endAngle >= 2 * Math.PI) {
						numSelectAnimate -= 1;
					}
				}

				drawArc( selected, arCanvas[MARKER].ctx);
            });
            if( numFavorites > 0) {
                for( i = 0; i < numFavorites; i++)  {
                    arFavorites[i].rotation += 0.1 * arFavorites[i].clockwise;
                    if( arFavorites[i].rotation > 6.3) {
                        arFavorites[i].rotation = 6.3;
                        arFavorites[i].clockwise *= -1;
                    }
                    else if( arFavorites[i].rotation < 0) {
                        arFavorites[i].rotation = -0;
                        arFavorites[i].clockwise *= -1;
                    }
                    util.drawText( arCanvas[MARKER].ctx, arFavorites[i]);
                }
            }
            if( arOutline.length > 0) {
                lw = Math.ceil( 1 / mtx.m[0]);
                for( i = 0; i < arOutline.length; i++) {
                    drawPath(  arOutline[i].path, arCanvas[MARKER].ctx, arOutlineParams[i].color, lw);
                }
            }
//			tm = Date.now() - st;
//			console.log( "animate time: " + tm);
				//  for 'throbbing' symbol
//            if( iAmHereSymbol) {
//                iAmHereSymbol.fontSize += throb;
//                if( iAmHereSymbol.fontSize > 200) {
//                    throb = -2;
//                }
//                if( iAmHereSymbol.fontSize < 100) {
//                    throb = 2;
//                }
//                iAmHereSymbol.font = "iAmHereSymbol.fontSize + "px Font Awesome 5 Free";
//                updateNeeded = true;
//            }
        }
    }
    
    function setIAmHere( symbol, label, x, y, color) {
        if(window.innerWidth < 400){
            iAmHereSymbol = {
                x: Number(x),
                y: Number(y) -36,
                text: symbol,
                fontSize: 40,
                font: "40px 'Font Awesome 5 Free'",
                fill: color
            };
        } else {
            iAmHereSymbol = {
                x: Number(x),
                y: Number(y) -36,
                text: symbol,
                fontSize: 76,
                font: "76px 'Font Awesome 5 Free'",
                fill: color
            };
        }
        iAmHereText = {
            x: Number(x),
            y: iAmHereSymbol.y - iAmHereSymbol.font,
            text: label,
            fontSize: 72,
			font: "bold 72px Arial",
            fill: color
        };
    }

    function clearIAmHere(){
        iAmHereSymbol = null;
        iAmHereText = null;
    }
    
    function clearCanvas() {
        var i = 0;
        for( i = 0; i < 4; i++) {
            arCanvas[i].ctx.save();
            arCanvas[i].ctx.setTransform(1,0,0,1,0,0);
            arCanvas[i].ctx.clearRect(0, 0, containerWidth, containerHeight);
            arCanvas[i].ctx.restore();
        }
    }
    
    function isInObject( obj, x, y) {
        if( obj === null || obj.path === null) {
            return false;
        }
        var i = 0;
        var len = obj.path.length;
        
        arCanvas[BOOTH].ctx.beginPath();
        arCanvas[BOOTH].ctx.moveTo( obj.path[0].x, obj.path[0].y);
        for( i = 1; i < len; i += 1) {
            arCanvas[BOOTH].ctx.lineTo( obj.path[i].x, obj.path[i].y);
        }
        return ( arCanvas[BOOTH].ctx.isPointInPath( x, y));
    }
    
    function goToPoint( newX, newY, newScale) {
        var panX = centerX - newX;      //  move drawing this much to get new point to center
        var panY = centerY - newY;
        zoomFinalScale = newScale;
        
        if( newX === centerX && newY === centerY) {
            if( newScale > mtx.m[0]) {
                effectInProgress = true;
                zooming = true;
                zoomChange = Math.round( 1000 * ( newScale - fitScale)) / 1000;
                lastStepTime = Date.now();
            }
        }
        else {
            effectInProgress = true;
            panFinalX = newX;
            panFinalY = newY;  

            panDist = Math.sqrt( panX * panX + panY * panY);
            panSin = panY / panDist;
            panCos = panX / panDist;
            
            if( mtx.m[0] > fitScale) {
                zoomChange = fitScale - mtx.m[0];
                zooming = true;

                lastStepTime = Date.now();

            }
            else {
                panning = true;

                lastStepTime = Date.now();
            }
        }
    }
    
    function updateEffect() {
        var tm = Date.now();
        var lapse = ( tm - lastStepTime) * config.MULTIPLIER;
        lastStepTime = tm;

        if( zooming) {
            zoomStepSize = Math.min( lapse * ZOOM_RATE, 0.5 * Math.abs( zoomChange));

            if( zoomChange > 0) {    // zoom  IN
                if( zoomFinalScale > mtx.m[0]) {
                    adjustZoomToScale( 1 + zoomStepSize / mtx.m[0]);
                }
                else {
                    zooming = false;
                    zoomFinalScale = 0;
                    zoomStepSize = 0;
                    effectInProgress = false;
                }
            }
            else {    
           //  ZOOM OUT
                if( mtx.m[0] > fitScale) {
                    if( mtx.m[0] - zoomStepSize < fitScale) {
                        zoomStepSize =  mtx.m[0] - fitScale + 0.0001;
                    }
                    adjustZoomToScale( 1 - zoomStepSize / mtx.m[0]);
                }
                else {
                    zooming = false;
                    panning = true;
                    lastStepTime = Date.now();
                }
            }
        }
        
        else if( panning) {
          //  var step = 3 * lapse;

            var stepX = -Math.round( lapse * panCos);
            if( stepX < 0) {
                if( centerX + stepX < panFinalX) {
                    stepX = panFinalX - centerX;        // centerX - panFinalX
                }
            }
            else {
                if( centerX + stepX > panFinalX) {
                    stepX = panFinalX - centerX;
                }
            }
            
            var stepY = -Math.round( lapse * panSin);
            if( stepY < 0) {
                
                if( centerY + stepY < panFinalY) {
                    stepY = panFinalY - centerY;        // centerY - panFinalY
                }
            }
            else {
                if( centerY + stepY > panFinalY) {
                    stepY = panFinalY - centerY;
                }
            }
            
            moveCanvas( -stepX, -stepY);
            
            //  check for sign of step and check <= to >=  ?? betting on exact match !!
            if( (centerX === panFinalX && centerY === panFinalY) || centerX > config.DRAWING_WIDTH ||
               centerY > config.DRAWING_HEIGHT) {
                panning = false;
                panFinalX = 0;
                panFinalY = 0;
                if( zoomFinalScale > mtx.m[0] ) {

                    zooming = true;
                    zoomChange = Math.round( 1000 * ( zoomFinalScale - mtx.m[0])) / 1000;
                }
                else{
                    effectInProgress = false;
                }
            }
        }
    }
   
    function miniMapHandler( evt) {
        moveCanvas( evt.data.x, evt.data.y);
    }
    
    function moveCanvas( dx, dy) {
        var i = 0;
        for( i = 0; i < 4; i++) {
            arCanvas[i].ctx.translate( dx, dy);
        }
        mtx.translate( dx, dy);
        centerX -= dx;
        centerY -= dy;
        
        updateNeeded = true;
    }
    
    function updateCheck() {
        if( effectInProgress) {
            updateEffect();
        }
        if( updateNeeded) {
            drawFloorPlan();
            doc.dispatchEvent( new FxEvent( "Floor_Plan_Change", { ratio:fitScale/mtx.m[0],
                                                                  x:centerX, y:centerY} ));
                                        
        }
        else {
			if( updateTimer) {
				clearTimeout( updateTimer);
			}
            updateTimer = setTimeout( updateCheck, 100);
        }
        
        updateAnimation();
    }
	
	function drawPdf( pdfDoc) {
//		var len = data.boothGraphics.length;
//		pdfDoc.rect( 1, 1, 790, 610).stroke( "#ff0000");
		
		pdf = pdfDoc;
		
		data.buildingText.forEach( function( txt) {
			pdfDoc.save();
			pdfText( pdfDoc, txt);
			pdfDoc.restore();
		});
		
		data.pavilions.forEach( function( pavilion) {
			pdfBooth( pdfDoc, pavilion);
		});
		
		data.boothGraphics.forEach( function( bth) {
			pdfBooth( pdfDoc, bth);
		});
		
		
		data.floorPlanText.forEach( function( txt) {
			pdfText( pdfDoc, txt);
		});
		
		if( data.arOverlays.length > 0) {
			doc.addEventListener( "OVERLAYS_READY", pdfAddOverlays);
		}
		else {
			pdfDoc.end();
		}
	}
	
	function pdfAddOverlays() {
		data.arOverlays.forEach( function( overlay) {
			if( overlay.ready) {
				//   ????  rotation  ???
				
			var obj = {
				width: overlay.w,
				height: overlay.h
			};

				pdf.image( overlay.imageData, overlay.x, overlay.y, obj);
			}
		
		});
		
		pdf.end();
	}
	
	function pdfBooth( pdf, bth) {
		var len = bth.path.length;
		var i = 0;
		
		pdf.moveTo( bth.path[0].x, bth.path[0].y);
		
		for( i = 1; i < len; i++) {
			pdf.lineTo( bth.path[i].x, bth.path[i].y);
		}
		pdf.lineTo( bth.path[0].x, bth.path[0].y);
		pdf.strokeColor(bth.strokeColor);
		pdf.fillColor(bth.fillColor);
		pdf.fillOpacity( bth.alpha);
		
		if( bth.type === "T") {
			pdf.fillAndStroke();
		}
		else if( bth.type === "F") {
			pdf.stroke();
		}
		else {
			pdf.fill();
		}
		
		if( bth.text) {
			bth.text.forEach( function( txt) {
				pdfText( pdf, txt);
			});
		}
	}
	
	function pdfText( pdf, txt) {
		var strLen = 0;
		pdf.save();
		
		pdf.fontSize( txt.fontSize);
		strLen = pdf.widthOfString( txt.text);
		
		var offX = -0.5 * strLen;
		var offY = -0.3 * txt.fontSize;
		
		pdf.fillColor( txt.fill);
		pdf.translate( txt.x, txt.y);
		if( txt.dRot !== 0) {
			pdf.rotate( txt.dRot);
		}
		var tw = 100 + strLen;
		pdf.text( txt.text, offX, offY, { width:tw});
		pdf.translate( 0, 0);
		
		pdf.restore();
	}
    
    function printFloorPlan( full) {
        var printScale = 0;
        var i;
        var pw = config.DRAWING_WIDTH + initialOffsetX;
        var ph = config.DRAWING_HEIGHT + initialOffsetY;
        var bod = doc.getElementsByTagName("body")[0];
        
        var scale = mtx.m[0];
        var m1 = mtx.m[1];          // y skew
        var m2 = mtx.m[2];          // x skew
        var m4 = mtx.m[4];          // x translation
        var m5 = mtx.m[5];          // y translation
        
        if( full && mtx.m[0] !== fitScale) {
            fitDrawing();
            drawFloorPlan();
        }
        var prtCanvas = doc.createElement( "canvas");
        
        prtCanvas.width = containerWidth;
        prtCanvas.height = containerHeight;
        
        var prtCtx = prtCanvas.getContext("2d");
        prtCtx.scale( fitScale, fitScale);
        
        printScale = fitScale;
//        
        for( i = 0; i < 4; i++) {
            arCanvas[i].ctx.setTransform( printScale, 0, 0, printScale, 0, 0);
        }
        prtCtx.drawImage( arCanvas[BASE].canvas, - initialOffsetX, - initialOffsetY, pw, ph);
        prtCtx.drawImage( arCanvas[BOOTH].canvas, - initialOffsetX, - initialOffsetY, pw, ph);
        prtCtx.drawImage( arCanvas[MARKER].canvas, - initialOffsetX, - initialOffsetY, pw, ph);
        prtCtx.drawImage( arCanvas[BOOTH_TEXT].canvas, - initialOffsetX, - initialOffsetY, pw, ph);
        
        prtCanvas.style.top = 0;
        prtCanvas.style.left = 0;
        
        bod.appendChild( prtCanvas);
        
        var dataUrl = prtCanvas.toDataURL();
        
        bod.removeChild( prtCanvas);
        
        for( i = 0; i < 4; i++) {
            arCanvas[i].ctx.setTransform( scale, m1, m2, scale, m4, m5);
        }
        mtx.m[0] = scale;
        mtx.m[1] = m1;
        mtx.m[2] = m2;
        mtx.m[3] = scale;
        mtx.m[4] = m4;
        mtx.m[5] = m5;
        
        updateNeeded = true;
        
        return dataUrl;
    }
    
    function remove2d() {
//		elemById( "floorplan").removeChild( container);
        var i;
        for( i = 0; i < arCanvas.length; i++) {
            container.removeChild( arCanvas[i].canvas);
        }
		clearTimeout( updateTimer);
        disableEvents();
    }
    
    function showFloorPlan() {		//  show2d
//		container.appendChild( container);
        var i;
        for( i = 0; i < arCanvas.length; i++) {
            container.appendChild( arCanvas[i].canvas);
        }
        enableEvents();
		updateCheck();
    }
    
    
    //////   DEBUG  //////////////////////////////////
    function logMatrix() {
        console.log( "MATRIX:  " + mtx.m[0] + ", " + mtx.m[1] + ", " + mtx.m[2] + ", " + 
                    mtx.m[3] + ", " + mtx.m[4] + ", " + mtx.m[5]);
    }
    ///////////////////////////////////////////////////
    

    //  Public interface
    return {
        addBoothGraphic: setBoothFillStyle,
        addBuilding: addBuilding,
        addGraphic: addGraphic,
        addOverlays: addOverlays,
        addToOutline: addToOutline,
        createBoothGradient: createBoothGradient,
        completeSetup: completeSetup,
        dragTo: dragTo,
		drawPdf: drawPdf,
        fit: fitDrawing,
        floorPlanToGlobal: floorPlanToGlobal,
		getIsReady: function() { return isReady;},
        getOffset: function() { return { x: initialOffsetX, y: initialOffsetY};},
        getX: function() { return mtx.m[4];  },
        getY: function() { return mtx.m[5]; },
        getScale: function() { return mtx.m[0]; },
        getSelected: function() { return arSelected; },
        globalToFloorPlan: globalToFloorPlan,
        goToPoint: goToPoint,
        highlightBooth: highlightBooth,
        hitTest: hitTest,
        logMatrix: logMatrix,
//        markBooth: markBooth,
        markFavorite: markFavorite,
        markSelected: markSelected,
        moveBy: function( dx, dy) {
            moveCanvas( dx, dy);
        },
        redraw: function() {
            updateNeeded = true;
                // if starting program, call once to start the loop
            if( !loopStarted) {
                loopStarted = true;
                drawFloorPlan();
            }
        },
        getFloorPlanImage: printFloorPlan,
        pointerDownAt: pointerDownAt,
        remove2d: remove2d,
        removeBoothText: removeBoothText,
        removeFavorite: removeFavorite,
        removeSelected: removeSelected,
        removeAllSelected: removeAllSelected,
        removeFromOutline: removeFromOutline,
        resizeHandler: resizeHandler,
        showFloorPlan: showFloorPlan,
        setIAmHere: setIAmHere,
        clearIAmHere: clearIAmHere,
        updateSelected: updateSelected,

        zoom: function( step) {
            var oStep = step; 
            step = step * mtx.m[0] * 0.1;
            if( step < 0 && mtx.m[0] + step < fitScale) {
                step = fitScale - mtx.m[0];
            }
            if( step > 0 || mtx.m[0] > fitScale) {
                adjustZoomToScale( (mtx.m[0] + step) / mtx.m[0], oStep);

            }  
        },
        zoomToCursor: function( step) {
            var oStep = step; 
            step = step * mtx.m[0] * 0.1;
            if( step < 0 && mtx.m[0] + step < fitScale) {
                step = fitScale - mtx.m[0];
            }
            if( step > 0 || mtx.m[0] > fitScale) {
                adjustScaleToCursor( (mtx.m[0] + step) / mtx.m[0]);
            } 
        },
        zoomTo: function( scale) {
            adjustZoomToScale( (mtx.m[0] + scale) / mtx.m[0]);
        }
    };
};